app.service("OrderQuoteService", ['$rootScope', function ($rootScope) {

    const requestService = $rootScope.service.request;
    const siteHelper = $rootScope.site_helper;

    this.saveQuoteDefaults = function (webquoteDefaults, callback) {
        const endpoint = '/request/api.php/users/_me';
        const data = {
            webQuoteData: true,
            type: 'user',
            webquote_defaults: webquoteDefaults
        }
        requestService.postJsonRequest(endpoint, data, function (success, data, messages) {
            if (success) {
                $rootScope.model.account.user_data.webquote_defaults = webquoteDefaults;
                siteHelper.addSuccessMessage('Quote default successfully updated!', messages);
            }
            if (callback) {
                callback(success, data, messages)
            }
        })
    }

    this.saveNewQuoteExtra = function (quoteExtra, callback) {

        const endpoint = '/request/api.php/users/_me/quote_items';
        const data = JSON.parse(JSON.stringify(quoteExtra));
        data.newItem = true;
        data.type = "quote_item";

        requestService.postJsonRequest(endpoint, data, function (success, data, messages) {
            if (success) {
                if (data._error) {
                    siteHelper.addErrorMessage(data._error, messages, null, true);
                } else {
                    siteHelper.addSuccessMessage('Item has been added to your Saved Extras', messages);
                }
            }
            if (callback) {
                callback(success, data, messages)
            }
        })
    }

    this.deleteQuoteExtra = function (quoteExtraID, callback) {

        const endpoint = '/request/api.php/users/' + $rootScope.model.account.user_data._nid + '/quote_items/' + quoteExtraID;

        requestService.deleteJsonRequest(endpoint, null, function (success, data, messages) {
            if (callback) {
                callback(success, data, messages)
            }
        })
    }

    this.addQuoteExtraToCurrentQuote = function (quoteExtra, callback) {

        const messages = [];

        const quantity = Number.isInteger(quoteExtra.quantity) ? parseInt(quoteExtra.quantity) : 0;
        if (quantity < 1) {
            siteHelper.addErrorMessage('Please enter a valid quantity', messages);
            if (callback) {
                callback(false, null, messages)
            }
            return;
        }

        if (quoteExtra.notes) {
            quoteExtra.cartname = quoteExtra.description + ' - ' + quoteExtra.notes;
        } else {
            quoteExtra.cartname = quoteExtra.description;
        }

        const currentOrder = $rootScope.model.order.current_order;
        const userData = $rootScope.model.account.user_data;

        if (!userData.webquote_defaults) {
            userData.webquote_defaults = {};
            userData.webquote_defaults.margin = 0;
            userData.webquote_defaults.discount = 0;
        }

        const lines = [{
            quantity: quantity,
            type: "quote_item",
            description: quoteExtra.cartname,
            price_each: quoteExtra.price_each,
            quote_margin: userData.webquote_defaults.margin,
            quote_discount: userData.webquote_defaults.discount
        }];

        if (currentOrder.type === undefined) {
            currentOrder.type = "weborder";
        }
        const endpoint = '/request/api.php/orders/build';
        const data = {
            collection: false,
            colour: "",
            currency: $rootScope.model.account.customer_data.currencyData.id,
            customer_code: $rootScope.service.account.getCustomerCode(),
            despatch_type: "standard",
            lines: lines,
            payment_type: "account",
            range: "",
            reference: 'testorder',
            weborder: true,
            style: "",
            type: currentOrder.type
        }

        requestService.postJsonRequest(endpoint, data, function (success, orderBuild, messages) {
            if (success) {

                if (orderBuild._errors && orderBuild._errors.lines) {
                    success = false;
                    for (let i = 0; i < orderBuild.lines.length; i++) {
                        siteHelper.addErrorMessage(orderBuild.lines[i]._errors, messages, null, true);
                    }
                } else {

                    $rootScope.model.order.current_order.lines.unshift(orderBuild.lines[0]);
                    siteHelper.addSuccessMessage('Extra added to your quotation', messages);

                    $rootScope.service.order.saveOrder();

                }
            }
            if (callback) {
                callback(success, data, messages)
            }
        })
    };

    this.convertQuoteToOrder = function (quote, callback) {
        quote = quote ? quote : $rootScope.model.order.current_order;

        const endpoint = '/request/api.php/orders/';

        if (quote && $rootScope.service.order_helper.isOrderQuote(quote) && quote.lines.length != 0) {

            for (let i = 0; i < quote.lines.length; i++) {
                if (quote.lines[i].type === "quote_item") {
                    quote.lines.splice(i, 1);
                    i--;
                }
            }

            const data = {
                collection: false,
                colour: "",
                currency: $rootScope.model.account.customer_data.currencyData.id,
                customer_code: $rootScope.service.account.getCustomerCode(),
                despatch_type: "standard",
                lines: quote.lines,
                payment_type: "account",
                range: "",
                reference: quote.reference,
                weborder: true,
                style: "",
                type: "weborder",
                submit_order: false,
                save_order: true
            }

            requestService.postJsonRequest(endpoint, data, callback)
        } else {
            callback(false, null, [])
        }
    }

    this.calculateQuotePrice = function (quoteLine) {
        const sublinesPrice = quoteLine._sublines_price;
        const quoteMargin = quoteLine.quote_margin ? quoteLine.quote_margin : 0;
        const quoteDiscount = quoteLine.quote_discount ? quoteLine.quote_discount : 0;
        if (quoteLine._quote_price) {
            return quoteLine._quote_price
        }
        if (!quoteLine._sublines_price) {
            return 0;
        }
        let price = sublinesPrice / (1 - quoteMargin / 100);
        price = price - price * quoteDiscount / 100;
        return Math.floor(price * 100) / 100;
    }

}]);
